<script lang="ts">
    export let text: string;
    export let label: string | undefined;
</script>

<span title={label}>{text}</span>